import { FileRights } from './usersEdit/fileRights/fileRights'
import { DatePicker } from './datePicker/datePicker'

export const Admin = (() => {
	const init = () => {
		FileRights.init()
		DatePicker.init()
	}

	return {
		init,
	}
})()
